import React from 'react';

import { Switch, Route, Redirect } from 'react-router';
import Home from 'pages/Home';
import DocumentViewer from 'pages/DocumentViewer';
import EmailVerifyAlert from 'pages/EmailVerifyAlert';
import Inbox from 'pages/Inbox';

import useAuth from 'components/Auth/useAuth';

export default React.forwardRef(function Routes(props, ref) {
  const auth = useAuth();

  if (!auth.isValid) {
    return (
      <Switch ref={ref}>
        <Route component={Home} />
      </Switch>
    );
  }

  if (auth.isUser && !auth.emailVerified) {
    return (
      <Switch ref={ref}>
        <Route component={EmailVerifyAlert} />
      </Switch>
    );
  }

  return (
    <Switch ref={ref}>
      <Route path="/d/:id" component={DocumentViewer} />
      <Route path="/view/:id" component={DocumentViewer} />
      <Route path="/inbox" component={Inbox} />
      <Route component={Home} />
    </Switch>
  );
});